module.exports = __webpack_public_path__ + "img/605352_E9CCC5_C7A8A3_A89291-256px.caa1a324.png";